import { Component, Input, OnChanges, OnInit } from '@angular/core';

type NaicsEntry = { naics_code: string; naics_title: string; count: number };
type NaicsDict = Record<string, NaicsEntry[]>;

// Short names used as chart labels — kept brief to avoid overflow
const NAICS_SECTOR_SHORT_NAMES: Record<string, string> = {
    '11': 'Agriculture',
    '21': 'Mining / Oil & Gas',
    '22': 'Utilities',
    '23': 'Construction',
    '31': 'Manufacturing', '32': 'Manufacturing', '33': 'Manufacturing',
    '42': 'Wholesale Trade',
    '44': 'Retail Trade', '45': 'Retail Trade',
    '48': 'Transportation', '49': 'Transportation',
    '51': 'Information',
    '52': 'Finance & Insurance',
    '53': 'Real Estate',
    '54': 'Prof. & Tech. Services',
    '55': 'Management',
    '56': 'Admin. & Support',
    '61': 'Education',
    '62': 'Health Care',
    '71': 'Arts & Entertainment',
    '72': 'Accommodation & Food',
    '81': 'Other Services',
    '92': 'Public Administration'
};


@Component({
    selector: 'app-industry-insights',
    templateUrl: './industry-insights.component.html',
    styleUrls: ['./industry-insights.component.css'],
    standalone: false
})
export class IndustryInsightsComponent implements OnInit, OnChanges {
    @Input() timeline: string = 'last 24 hours';
    @Input() isDarkTheme = false;
    @Input() naics_dict: NaicsDict = {};

    allIndustryData: { friendly: string; count: number; name: string }[] = [];

    minimizeBar = false;
    minimizeDonut = false;

    ngOnInit() {
        this.loadIndustryData();
    }

    ngOnChanges() {
        this.loadIndustryData();
    }

    private loadIndustryData() {
        const naicsTwoDigit = (this.naics_dict['2'] ?? []).filter(s => s.naics_code !== '0');
        if (naicsTwoDigit.length) {
            // Merge codes that share a sector name ex) 31/32/33 Manufacturing
            const merged = new Map<string, { friendly: string; count: number; name: string }>();
            for (const s of naicsTwoDigit) {
                const title = NAICS_SECTOR_SHORT_NAMES[s.naics_code] ?? ('Sector ' + s.naics_code);
                if (merged.has(title)) {
                    merged.get(title)!.count += s.count;
                } else {
                    merged.set(title, { friendly: title, count: s.count, name: s.naics_code });
                }
            }
            this.allIndustryData = Array.from(merged.values())
                .sort((a, b) => b.count - a.count);
        } else {
            this.allIndustryData = [];
        }
    }

    minimizedBar() {
        this.minimizeBar = !this.minimizeBar;
    }

    minimizedDonut() {
        this.minimizeDonut = !this.minimizeDonut;
    }
}
